"use client";

import { useEffect } from "react";
import { useTranslations } from "next-intl";
import posthog from "posthog-js";
import Link from "@/components/ui/LocaleLink";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations("errors");

  useEffect(() => {
    console.error("[GlobalError]", error);
    // Report to PostHog error tracking (captured even without analytics consent).
    posthog.captureException(error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-surface px-21 py-55 text-center">
      <p className="text-xs font-semibold uppercase tracking-widest text-gold-ink">
        {t("errorEyebrow")}
      </p>
      <h1 className="mt-13 font-serif text-4xl uppercase leading-tight text-navy">
        {t.rich("errorTitle", { em: (chunks) => <em className="italic">{chunks}</em> })}
      </h1>
      <p className="mx-auto mt-13 max-w-sm text-sm leading-relaxed text-gray-600">
        {t("errorBody")}
      </p>
      {error.digest && (
        <p className="mt-8 font-mono text-xs text-gray-500">
          {t("errorId")} {error.digest}
        </p>
      )}
      <div className="mt-34 flex flex-wrap justify-center gap-13">
        <button
          onClick={reset}
          className="rounded-control bg-gold px-21 py-13 text-sm font-semibold uppercase tracking-[0.04em] text-navy transition-colors hover:bg-gold-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold"
        >
          {t("tryAgain")}
        </button>
        <Link
          href="/"
          className="rounded-control border border-navy/20 px-21 py-13 text-sm font-semibold uppercase tracking-[0.04em] text-navy transition-colors hover:border-navy/50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold"
        >
          {t("backToHome")}
        </Link>
      </div>
    </div>
  );
}
